import * as React from 'react';
import { ComponentProps } from 'ui/common';
import { ButtonTertiary } from 'ui/common/button/button-tertiary';
import { ButtonInline } from 'ui/common/button/button-inline';
import styles from './log-link-button.scss';
import { withOpenState, OpenStateInjectedProps } from 'ui/common/enhancers';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { IconType } from 'react-icons/lib';

export interface LogLinkButtonComponentTranslations {
  textDone?: string;
  textTitle?: string;
}

export interface LogLinkButtonProps {
  icon?: IconType;
  inline?:boolean;
  visible?: boolean;
}

export type LogLinkButtonComponentProps = ComponentProps & OpenStateInjectedProps
                                              & LogLinkButtonProps & LogLinkButtonComponentTranslations;

export class LogLinkButtonComponent extends React.Component<LogLinkButtonComponentProps> {
  private closeModal = () => {
    const {isOpen, close} = this.props;

    isOpen && close();
  };

  public render() {

    const {
      componentId,
      label,
      children,
      isOpen,
      open,
      textDone,
      textTitle,
      icon,
      inline,
      visible=true
    } = this.props;

    if (!visible) {
      return null;
    }

    const childItems =
            <ul className={styles.items}>
              {
                React.Children.map(children, (child, i) =>
                  <li className={styles.item}>
                    {child}
                  </li>
                )
              }
            </ul>;

    const logModal =
            <ModalWrapper
              headerTitle={textTitle}
              btnTitle={textDone}
              onClose={this.closeModal}
              onDone={this.closeModal}
              largeSize={false}>
                {childItems}
            </ModalWrapper>;

    const linkButton = (
      inline ?
        <ButtonInline onClick={open} icon={icon}>
          {label && label.text}{!icon ? <MdKeyboardArrowRight /> : ''}
        </ButtonInline>
      :
        <ButtonTertiary onClick={open} icon={icon}>
          {label && label.text}
        </ButtonTertiary>
    );

    return (
        <div id={componentId} className={`${styles.logLinkButtonWrapper}`}>
          {linkButton}
          {isOpen && logModal}
        </div>
      );
  }
}

const c = withOpenState()(LogLinkButtonComponent);

export { c as LogLinkButton };
